<template>
  <div>
    <div class="pickr-container" :class="{'active': getActiveCustomColor()}" />
  </div>
</template>

<script>
import ColorPicker from '@/components/presentations/ColorPicker.vue'

export default {
  name: 'ColorPickerView',
  extends: ColorPicker,
  props: {
    color: {
      type: String,
      default: null,
    },
    change: {
      type: Function,
      default: null,
    },
  },
  mounted() {
    this.pickr.on('init', () => {
      this.pickr.setColor(this.color)
    })
  },
  methods: {
    updateSlide(payload) {
      const color = payload.baseColour
      this.$emit('change', color)
    },
  },
}
</script>
